import React from 'react';
import messages from '../../../messages';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useLinesContext } from '../../../contexts/Lines';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { updateProduct } from '../../API/product';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import * as yup from 'yup';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Step from '../BuildingBlocks/Stepper/Step';
import cloneDeep from 'lodash.clonedeep';
import ProductDetails from './product-details/ProductDetails';

const useStyles = makeStyles((theme: any) => ({
  subHeader: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  textField: {
    maxWidth: 400,
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(1),
    },
  },
}));

export default function ProductName() {
  const classes = useStyles();
  const snackbar = useSnackbarContext();
  const { trackEvent } = useEventTrackerContext();
  const { setLoading, goForward } = useOnboardingContext();
  const { products, setProducts } = useLinesContext();
  const newestProduct = products[products?.length - 1];

  async function handleSubmit(values: { name: string }) {
    if (!newestProduct) {
      return snackbar.show(messages.product.errors.notFoundUpdate, 'error');
    }
    try {
      if (newestProduct?.name !== values.name) {
        setLoading(true);
        await updateProduct(newestProduct?.id, { name: values.name });
        const updatedProducts = cloneDeep(products).map((product) => {
          if (product.id === newestProduct.id) {
            product['name'] = values.name;
          }
          return product;
        });
        setProducts(updatedProducts);
      }
      trackEvent({ event: 'entered_product_name', product_name: values.name });
      goForward();
    } catch (error) {
      snackbar.show(messages.general.saveError, 'error');
    }
    setLoading(false);
  }

  let newestProductName = newestProduct?.name;
  newestProductName = newestProductName?.split(' ')?.slice(0, 4).join(' ');

  return (
    <Step
      initialValues={{ name: newestProductName || '' }}
      validationSchema={yup.object({
        name: yup.string().required(),
      })}
      onSubmit={handleSubmit}
      component={() => {
        return (
          <ProductDetails product={newestProduct} step={2}>
            <Field
              name="name"
              label="Product Name"
              component={TextField}
              variant="outlined"
              fullWidth
              className={classes.textField}
            />
          </ProductDetails>
        );
      }}
    />
  );
}
